module.exports = __webpack_public_path__ + "static/media/candidate_settings.9c982fd3.png";